<template>
  <div class="instructions-panel">
    <div>
      <div class="--uppercase">
        {{ $t('tactics.instructions.transitions.defensive.title') }}
      </div>
      <TheTeamInstructionsTransitionsDefensive />
    </div>

    <div>
      <div class="--uppercase">
        {{ $t('tactics.instructions.transitions.attacking.title') }}
      </div>
      <TheTeamInstructionsTransitionsAttacking />
    </div>

    <div>
      <div class="--uppercase">
        {{ $t('tactics.instructions.transitions.goalkeeper.title') }}
      </div>
      <TheTeamInstructionsTransitionsGoalkeeper />
    </div>
  </div>
</template>

<script>
import TheTeamInstructionsTransitionsAttacking from './TheTeamInstructionsTransitionsAttacking';
import TheTeamInstructionsTransitionsDefensive from './TheTeamInstructionsTransitionsDefensive';
import TheTeamInstructionsTransitionsGoalkeeper from './TheTeamInstructionsTransitionsGoalkeeper';

export default {
  components: {
    TheTeamInstructionsTransitionsAttacking,
    TheTeamInstructionsTransitionsDefensive,
    TheTeamInstructionsTransitionsGoalkeeper,
  }
}
</script>

<style scoped>

</style>
